import { useCallback, useEffect } from 'react';
export const useReflowOnTransition = (ref, deps = [], delay = 270) => {
    const forceReflow = useCallback(() => {
        try {
            window.dispatchEvent(new Event('resize'));
            window.dispatchEvent(new Event('scroll'));
        }
        catch (_a) { }
    }, []);
    useEffect(() => {
        const el = ref.current;
        if (!el)
            return;
        const onEnd = (e) => {
            if (e.propertyName === 'max-height' || e.propertyName === 'opacity') {
                requestAnimationFrame(() => forceReflow());
            }
        };
        el.addEventListener('transitionend', onEnd);
        return () => el.removeEventListener('transitionend', onEnd);
    }, [ref, forceReflow]);
    useEffect(() => {
        const tid = setTimeout(() => forceReflow(), delay);
        return () => clearTimeout(tid);
    }, [forceReflow, delay, ...deps]);
};
